module.exports = __webpack_public_path__ + "static/media/SecondarySchool.b622ef72.png";